import { forwardRef, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import styles from "./styles.module.css";
import { setConfirmationModalId } from "../../Redux/features/modalsSlice";
import { TabPage } from "../../components";
import classNames from "classnames";
import ReviewTranscriptTable from "./ReviewTranscriptTable";

const FinanceDashboard = () => {
  const [menuId, setMenuId] = useState("");
  const [currentTab, setCurrentTab] = useState(1);
  const menuRef = useRef();

  //Handle closing action menu when you click outside of it
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target))
        setMenuId("");
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <TabPage pageTitle="Finance/ Pending Requests">
      <div className={styles.tab_container}>
        <div
          className={classNames(
            styles.tab_item,
            currentTab === 1 && styles.active
          )}
          onClick={() => setCurrentTab(1)}
        >
          Transcripts
        </div>
        <div
          className={classNames(
            styles.tab_item,
            currentTab === 2 && styles.active
          )}
          onClick={() => setCurrentTab(2)}
        >
          Proficiency
        </div>
        <div
          className={classNames(
            styles.tab_item,
            currentTab === 3 && styles.active
          )}
          onClick={() => setCurrentTab(3)}
        >
          Post Graduate
        </div>
        <div
          className={classNames(
            styles.tab_item,
            currentTab === 4 && styles.active
          )}
          onClick={() => setCurrentTab(4)}
        >
          NCE
        </div>
      </div>
      <div className="grid w-full h-full">
        {currentTab === 1 && (
          <ReviewTranscriptTable
            ActionMenu={ActionMenu}
            menuId={menuId}
            setMenuId={setMenuId}
            requestType={1}
          />
        )}
        {currentTab === 2 && (
          <ReviewTranscriptTable
            ActionMenu={ActionMenu}
            menuId={menuId}
            setMenuId={setMenuId}
            requestType={2}
          />
        )}
        {currentTab === 3 && (
          <ReviewTranscriptTable
            ActionMenu={ActionMenu}
            menuId={menuId}
            setMenuId={setMenuId}
            requestType={3}
          />
        )}
        {currentTab === 4 && (
          <ReviewTranscriptTable
            ActionMenu={ActionMenu}
            menuId={menuId}
            setMenuId={setMenuId}
            requestType={4}
          />
        )}
      </div>
    </TabPage>
  );
};

export default FinanceDashboard;

const ActionMenu = forwardRef(
  (
    {
      id,
      menuId,
      setApproveOrderNumber,
      handleView,
      handleReject,
      orderNo,
      hasDocumentToView,
    },
    ref
  ) => {
    const dispatch = useDispatch();

    return menuId === id ? (
      <div
        className="absolute bg-white flex flex-col top-full right-0 z-[100] min-w-[140px] rounded-lg shadow-xl border border-gray-200 py-2 animate-in fade-in zoom-in duration-200 origin-top-right"
        ref={ref}
      >
        <p
          className="py-2.5 px-4 text-sm font-medium text-gray-700 cursor-pointer hover:bg-blue-50 hover:text-blue-700 transition-colors"
          onClick={() => {
            dispatch(setConfirmationModalId("FinanceApproveTranscript"));
            setApproveOrderNumber(orderNo);
          }}
        >
          Approve
        </p>
        <p
          className="py-2.5 px-4 text-sm font-medium text-gray-700 cursor-pointer hover:bg-red-50 hover:text-red-700 transition-colors"
          onClick={() => handleReject(orderNo)}
        >
          Reject
        </p>
        <p
          className={`py-2.5 px-4 text-sm font-medium text-gray-700 cursor-pointer hover:bg-gray-50 hover:text-gray-900 transition-colors ${
            !hasDocumentToView && "hidden"
          }`}
          onClick={() => handleView(orderNo)}
        >
          View
        </p>
      </div>
    ) : null;
  }
);
